import axios from 'axios';
import { ITestChatRegisterData } from 'chat-ui/src/types';
import { MessageData } from '@/types';

export const axiosInstanceChat = axios.create({
  baseURL: import.meta.env.VITE_CHAT_URL,
});

export const testChatRegister = async (
  projectId: string | undefined,
): Promise<ITestChatRegisterData> => {
  if (!projectId) {
    throw new Error('Project ID is not defined');
  }
  const { data } = await axiosInstanceChat.post(`/chat/test/${projectId}`);
  return data;
};

export const getTestChatHistory = async (conversation_id?: string): Promise<MessageData[]> => {
  const url = conversation_id ? `/chat/history/${conversation_id}` : '/chat/history';
  const reponse = await axiosInstanceChat.get(url);

  return reponse.data;
};
